var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pb-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Identitas"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    staticClass: "form-control",
    attrs: {
      "list": _vm.ref_identitas,
      "option-value": "kd_id",
      "option-text": "URAIAN",
      "value": _vm.model('jns_identitas'),
      "name": "Jenis Identitas",
      "placeholder": "Jenis Identitas"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('jns_identitas', $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Identitas"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.model('jns_identitas') === '5' ? 'required|min:16' : 'required'),
      expression: " model('jns_identitas') === '5' ? 'required|min:16' : 'required' "
    }],
    class: _vm.errors.has('Nomor Identitas') ? 'is-invalid' : '',
    attrs: {
      "name": "Nomor Identitas",
      "type": "text",
      "value": _vm.model('no_identitas'),
      "placeholder": "Nomor Identitas"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_identitas', $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nomor Identitas')),
      expression: "errors.has('Nomor Identitas')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Nomor Identitas')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nama"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "value": _vm.model('nama'),
      "placeholder": "Nama Pemohon"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('nama', $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Alamat"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "value": _vm.model('alamat'),
      "placeholder": "Alamat"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('alamat', $event)
      }
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mx-3"
  }, [_c('p', {
    staticClass: "mr-3"
  }, [_vm._v("Menggunakan Kuasa?")]), _vm._v(" "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "primary",
      "pill": true,
      "checked": true
    },
    model: {
      value: (_vm.fl_kuasa),
      callback: function($$v) {
        _vm.fl_kuasa = $$v
      },
      expression: " fl_kuasa "
    }
  })], 1), _vm._v(" "), (_vm.fl_kuasa) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Identitas yang dikuasakan"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    staticClass: "form-control",
    attrs: {
      "list": _vm.ref_identitas,
      "option-value": "kd_id",
      "option-text": "URAIAN",
      "value": _vm.model('jns_identitas_kuasa'),
      "name": "Jenis Identitas",
      "placeholder": "Jenis Identitas"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('jns_identitas_kuasa', $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Identitas yang dikuasakan"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.model('jns_identitas_kuasa') === '5' ? 'min:16' : ''),
      expression: " model('jns_identitas_kuasa') === '5' ? 'min:16' : '' "
    }],
    class: _vm.errors.has('Nomor Identitas yang dikuasakan') ? 'is-invalid' : '',
    attrs: {
      "name": "Nomor Identitas yang dikuasakan",
      "type": "text",
      "value": _vm.model('no_identitas_kuasa'),
      "placeholder": "Nomor Identitas yang dikuasakan"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_identitas_kuasa', $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nomor Identitas yang dikuasakan')),
      expression: "errors.has('Nomor Identitas yang dikuasakan')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Nomor Identitas yang dikuasakan')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nama yang dikuasakan"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "value": _vm.model('nama_kuasa'),
      "placeholder": "Nama Pemohon"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('nama_kuasa', $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Alamat yang dikuasakan"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "value": _vm.model('alamat_kuasa'),
      "placeholder": "Alamat yang dikuasakan"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('alamat_kuasa', $event)
      }
    }
  })], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Moda Angkutan"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    staticClass: "form-control",
    attrs: {
      "list": [{
          id_angkutan: '1',
          nama_angkutan: 'Laut'
        },
        {
          id_angkutan: '2',
          nama_angkutan: 'Udara'
        },
        {
          id_angkutan: '3',
          nama_angkutan: 'Darat'
        }
      ],
      "option-value": "id_angkutan",
      "custom-text": function (item) { return ((item.id_angkutan) + " - " + (item.nama_angkutan)); },
      "value": _vm.model('moda_angkutan'),
      "name": "Jenis Perizinan",
      "placeholder": "Moda Angkutan"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('moda_angkutan', $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tempat Penimbunan (Gudang)"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    staticClass: "form-control",
    attrs: {
      "list": _vm.gudang,
      "option-value": "ID_GUDANG",
      "custom-text": function (item) { return ((item.ID_GUDANG) + " - " + (item.NM_GUDANG)); },
      "name": "Jenis Perizinan",
      "value": _vm.model('id_gudang'),
      "placeholder": "Tempat Penimbunan"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('id_gudang', $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nama Sarana Pengangkut / Lori"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "value": _vm.model('nama_sarkut'),
      "placeholder": "Nama Sarana Angkutan"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('nama_sarkut', $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Voyage / Plat Nomor Kendaraan"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "value": _vm.model('no_voyage'),
      "placeholder": "Nomor Voyage / Plat Nomor Kendaraan"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_voyage', $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Pelabuhan Muat"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    staticClass: "form-control",
    attrs: {
      "list": _vm.pelabuhan,
      "option-value": "ID_LOKASI",
      "custom-text": function (item) { return ((item.ID_LOKASI) + " - " + (item.NM_LOKASI)); },
      "value": _vm.model('pel_muat'),
      "name": "Jenis Perizinan",
      "placeholder": "Pelabuhan Muat"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('pel_muat', $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Pelabuhan Tujuan"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    staticClass: "form-control",
    attrs: {
      "list": _vm.pelabuhan,
      "option-value": "ID_LOKASI",
      "custom-text": function (item) { return ((item.ID_LOKASI) + " - " + (item.NM_LOKASI)); },
      "name": "Jenis Perizinan",
      "value": _vm.model('pel_tujuan'),
      "placeholder": "Pelabuhan Tujuan"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('pel_tujuan', $event)
      }
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Bruto"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "currency": "Kg",
      "currency-symbol-position": "suffix",
      "separator": ".",
      "placeholder": "Bruto Barang",
      "precision": 2,
      "value": _vm.model('bruto')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('bruto', $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Netto"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "currency": "Kg",
      "currency-symbol-position": "suffix",
      "separator": ".",
      "placeholder": "Netto Barang",
      "precision": 2,
      "value": _vm.model('netto')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('netto', $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Estimasi Tanggal Pengeluaran"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date",
      "value": _vm.model('tgl_pengeluaran')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('tgl_pengeluaran', $event)
      }
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-borderless table-responsive"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "disabled": "",
      "type": "text",
      "size": "50",
      "value": _vm.model('no_identitas')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_identitas', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_identitas_penerima'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_identitas_penerima) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum\n              Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_identitas_penerima) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_identitas_penerima))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '2') ? _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "placeholder": "Nomor STNK",
      "value": _vm.model('no_stnk'),
      "type": "text"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_stnk', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    attrs: {
      "type": "date",
      "value": _vm.model('tgl_stnk')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('tgl_stnk', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_stnk'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_stnk) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum\n              Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_stnk) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_stnk))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '2') ? _c('tr', [_vm._m(3), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "placeholder": "Nomor BPKB",
      "value": _vm.model('no_bpkb'),
      "type": "text"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_bpkb', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    attrs: {
      "type": "date",
      "value": _vm.model('tgl_bpkb')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('tgl_bpkb', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_bpkb'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_bpkb) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum\n              Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_bpkb) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_bpkb))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '2') ? _c('tr', [_vm._m(4), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "placeholder": "Nomor Surat Jalan",
      "value": _vm.model('no_surat_jalan'),
      "type": "text"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_surat_jalan', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    attrs: {
      "type": "date",
      "value": _vm.model('tgl_surat_jalan')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('tgl_surat_jalan', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_surat_jalan'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_surat_jalan) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum\n              Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_surat_jalan) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_surat_jalan))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.fl_kuasa) ? _c('tr', [_vm._m(5), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "value": _vm.model('no_identitas_kuasa'),
      "disabled": "",
      "type": "text"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_identitas_kuasa', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_identitas_pengirim'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_identitas_pengirim) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum\n              Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_identitas_pengirim) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_identitas_pengirim))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '1') ? _c('tr', [_vm._m(6), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "placeholder": " Nomor Kartu Keluarga",
      "value": _vm.model('no_kk'),
      "type": "text"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_kk', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_kk'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_kk) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_kk) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_kk))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '1') ? _c('tr', [_c('td', [_vm._v("Surat Pindah Dukcapil")]), _vm._v(" "), _c('td', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    attrs: {
      "disabled": this.$store.state.barpin.isDisabled,
      "placeholder": "Nomor Surat Dukcapil",
      "value": _vm.model('no_dukcapil'),
      "type": "text"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_dukcapil', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    attrs: {
      "type": "date",
      "value": _vm.model('tgl_dukcapil')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('tgl_dukcapil', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_dukcapil'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_dukcapil) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum\n              Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_dukcapil) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_dukcapil))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '1') ? _c('tr', [_vm._m(7), _vm._v(" "), _c('td', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    attrs: {
      "disabled": this.$store.state.barpin.isDisabled,
      "placeholder": "Nomor Surat Pindah",
      "value": _vm.model('no_surat_pindah'),
      "type": "text"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_surat_pindah', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    attrs: {
      "type": "date",
      "value": _vm.model('tgl_pindah')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('tgl_pindah', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_pindah'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_pindah) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum\n              Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_pindah) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_pindah))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.fl_kuasa) ? _c('tr', [_c('td', [_vm._v("Surat Kuasa")]), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "placeholder": "Nomor Surat Kuasa",
      "type": "text",
      "value": _vm.model('no_surat_kuasa')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_surat_kuasa', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "type": "date",
      "value": _vm.model('tgl_surat_kuasa')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('tgl_surat_kuasa', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_kuasa'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_kuasa) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum\n              Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_kuasa) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_kuasa))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '1') ? _c('tr', [_vm._m(8), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "placeholder": "Nomor Surat Pernyataan",
      "type": "text",
      "value": _vm.model('no_surat_pernyataan')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_surat_pernyataan', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "type": "date",
      "value": _vm.model('tgl_surat_pernyataan')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('tgl_surat_pernyataan', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_pernyataan'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_pernyataan) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum\n              Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_pernyataan) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_pernyataan))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '1') ? _c('tr', [_c('td', [_vm._v("Surat Rekomendasi BP")]), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "placeholder": "Nomor Surat Pernyataan",
      "type": "text",
      "value": _vm.model('no_surat_rekombp')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_surat_rekombp', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "type": "date",
      "value": _vm.model('tgl_surat_rekombp')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('tgl_surat_rekombp', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_rekombp'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_rekombp) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum\n              Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_rekombp) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_rekombp))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('tr', [_vm._m(9), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "placeholder": "Nomor Packing List",
      "type": "text",
      "value": _vm.model('no_pl')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_pl', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "type": "date",
      "value": _vm.model('tgl_pl')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('tgl_pl', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_pl'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_pl) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_pl) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_pl))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '2') ? _c('tr', [_vm._m(10), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "placeholder": "Nomor Gesek Kendaraan",
      "type": "text",
      "value": _vm.model('no_bukti_gesek')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_bukti_gesek', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "type": "date",
      "value": _vm.model('tgl_bukti_gesek')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('tgl_bukti_gesek', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_bukti_gesek'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_bukti_gesek) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum\n              Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_bukti_gesek) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_bukti_gesek))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Lain-lain")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_lain_lain'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_lain_lain) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum\n              Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_lain_lain) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_lain_lain))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("File Upload")]), _vm._v(" "), _c('th', [_vm._v("Nomor")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Identitas (KTP/NPWP/SIM)"), _c('code', [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Nomor STNK"), _c('code', [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Nomor BPKB "), _c('code', [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Nomor Surat Jalan"), _c('code', [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Identitas Kuasa (KTP/NPWP/SIM)"), _c('code', [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Kartu Keluarga"), _c('code', [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Surat Keterangan Pindah (Surat Mutasi/Lainnya)"), _c('code', [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Surat Pernyataan"), _c('code', [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Packing List"), _c('code', [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Bukti Gesek Kendaraan"), _c('code', [_vm._v("*")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40c5758f","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ppftz/perekaman/Step-1.vue
// module id = 347
// module chunks = 0